export const ORDER_FIELD_NAME = `orderRank` as const

export const API_VERSION = `2021-09-01` as const
